<template>
  <div class="refund-spu-list-widget">
    <div v-if="detail.role && detail.role.name" class="store-info">{{ detail.role.name }}</div>

    <div v-for="(group, index) in tableData" :key="index" class="promotion-group">
      <!-- <div v-if="group.promotion && group.promotion.title" class="promotion-title">
        <div class="promotion-tag flex-center t-c origin" v-if="itemData.promotion&&itemData.promotion.title">特價</div>
				<div class="promotion-tag flex-center t-c blue" v-else-if="itemData.type==0">普通商品</div>
				<div class="promotion-tag flex-center t-c red" v-else-if="itemData.type==1">包裹</div>
				<span v-if="itemData.type==1">
					{{itemData.promotionJson | promotionTitle }}
				</span>
      </div> -->

      <div class="left-promotion flex a-i-c">
				<div class="promotion-tag flex-center t-c origin" v-if="group.promotion&&group.promotion.title">特價</div>
				<div class="promotion-tag flex-center t-c blue" v-else-if="group.orderItemList[0].type==0">普通商品</div>
				<div class="promotion-tag flex-center t-c red" v-else-if="group.orderItemList[0].type==1">包裹</div>
				<span v-if="group.promotion&&group.promotion.title">
           {{ group.promotion.title }}
				</span>
			</div>



      <order-detail-spu-list-item
        v-for="item in group.orderItemList"
        :key="item.id"
        :item-data="item"
        :detail="detail"
      />
      <div v-if="group.promotionPrice" class="subtotal">小計：NT$ {{ group.promotionPrice }}</div>

      <div class="diviser-line" v-if="group.promotion&&group.promotion.title"></div>

    </div>

  </div>
</template>

<script>
import orderDetailSpuListItem from "./order-detail-spu-list-item";

const toGroups = (source) => (source ? (source.promotionItemList || [])
  .map((group) => ({ promotion: group.promotion, promotionPrice: group.promotionPrice, orderItemList: group.orderItemList || [] }))
  .concat((source.otherItemList || []).map((item) => ({ promotion: null, promotionPrice: null, orderItemList: [item] }))) : []);

export default {
  name: "refund-spu-list-widget",
  components: { orderDetailSpuListItem },
  props: { detail: { type: Object, default: () => ({}) } },
  computed: {
    tableData() {
      const groups = toGroups(this.detail.promotionOrderItem);
      if (groups.some((group) => group.orderItemList.length)) return groups;
      const refundGroups = toGroups(this.detail.refundPromotionOrderItem);
      if (refundGroups.some((group) => group.orderItemList.length)) return refundGroups;
      return (this.detail.orderItemList || []).filter((item) => Number(item.type) !== 1)
        .map((item) => ({ promotion: null, promotionPrice: null, orderItemList: [item] }));
    },
  },
  mounted() {
    console.log(this.tableData);
  }

};
</script>

<style lang="less" scoped>
.store-info { border-bottom: 1px solid #f3f3f3; color: #323232; font-size: 15px; font-weight: bold; margin-bottom: 10px; padding: 10px 0; }
.promotion-group { margin-bottom: 15px; }
.subtotal { color: #909090; font-size: 16px; font-weight: bold; padding: 10px 0; text-align: right; }
.diviser-line{
    width: 100%;
    height: 2px;
    background-color: #e3e3e3;
    margin-top: 10px;
}

.flex-center{
  display: flex;
  align-items: center;
  justify-content: center;
}
.t-c{
  text-align: center;
}

.left-promotion{
				display: flex;
				font-size: 12px;
				color: #6F6F6F;
				align-items: center;
				.promotion-tag{
					border-radius: 4px;
					border: 1px solid #323233;
					color: #323233;
					font-size: 12px;
					padding: 2px 8px;
					margin-right: 5px;
					white-space: nowrap;
					min-width: 50px;
					&.red{
						border: 1px solid #52c41a;
						color: #52c41a;
					}
					&.blue{
						border: 1px solid #C9C9C9;
						background-color: #F5F5F5;
						color: #4B4B4B;
					}
					&.origin{
						border: 1px solid #FFD3B2;
						color: #EF6500;
						background-color: #FFF3EB !important;
					}
				}
			}
</style>
